import { render, staticRenderFns } from "./RegulatedDashboardItem.vue?vue&type=template&id=3776daa6&scoped=true&"
import script from "./RegulatedDashboardItem.vue?vue&type=script&lang=ts&"
export * from "./RegulatedDashboardItem.vue?vue&type=script&lang=ts&"
import style0 from "./RegulatedDashboardItem.vue?vue&type=style&index=0&id=3776daa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776daa6",
  null
  
)

export default component.exports